import { render, staticRenderFns } from "./FreezePeriods.vue?vue&type=template&id=6421c689&scoped=true"
import script from "../../../scripts/partials/dashboard-charts/FreezePeriods.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/FreezePeriods.js?vue&type=script&lang=js&external"
import style0 from "./FreezePeriods.vue?vue&type=style&index=0&id=6421c689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421c689",
  null
  
)

export default component.exports